[
  {
    "code": "MRH",
    "name": "Malta – Mriehel",
    "lat": 35.8878,
    "lon": 14.4664,
    "country": "MT"
  },
  {
    "code": "MRH-L1",
    "name": "Malta – Mriehel (Level 1)",
    "lat": 35.8878,
    "lon": 14.4664,
    "country": "MT"
  },
  {
    "code": "PTM5",
    "name": "Portomaso – Level 5",
    "lat": 35.9236,
    "lon": 14.4906,
    "country": "MT"
  },
  {
    "code": "PTM-RLG",
    "name": "Portomaso – Religa",
    "lat": 35.924,
    "lon": 14.4912,
    "country": "MT"
  },
  {
    "code": "PT",
    "name": "Malta – Portomaso (PT)",
    "lat": 35.921,
    "lon": 14.489,
    "country": "MT"
  },
  {
    "code": "RLG",
    "name": "Malta – Religa",
    "lat": 35.9245,
    "lon": 14.4918,
    "country": "MT"
  },
  {
    "code": "TWN",
    "name": "Taiwan – Taipei",
    "lat": 25.033,
    "lon": 121.5654,
    "country": "TW"
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "lat": 25.033,
    "lon": 121.5654,
    "country": "TW"
  }
]
